import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const MapfunctionForTechnicalSanction = () => {
    const [proposalData, setProposalData] = useState({});
    const nav = useNavigate();
    const openedRef = useRef(false);

    useEffect(() => {
        const savedFormData = sessionStorage.getItem("createTechnicalForm");
        if (savedFormData && !openedRef.current) {
            const data = JSON.parse(savedFormData);
            console.log("data", data);

            setProposalData(data);
            let getGeometryOfWork = data.getGeometryOfWork;
            if (getGeometryOfWork === "Line") getGeometryOfWork = "l";
            if (getGeometryOfWork === "Point") getGeometryOfWork = "p";
            if (getGeometryOfWork === "Polygon") getGeometryOfWork = "a";
            // Open Gram Manchitra in new tab automatically
            const gpCode = data.GPCode ;
            const dpCode = data.DPCode ;
            const proposalUid = data.sanctionNo ;
            const rddUid = data.rddUid ;
            const projectId = data.proposalUid || "01";
            const coordinate = getGeometryOfWork || "l";
            console.log("gpcode",gpCode);
            console.log("dpcode",dpCode);
            
            if(!gpCode&& !dpCode){
                alert("GP/DP Code not found !!!!");
                nav(`/AdminDashboard/TechnicalSanction/${proposalUid}`);
            } 

            const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg";
            if (gpCode) {
                console.log("gpcode");
                
                 const url = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${gpCode}&activityCode=${proposalUid}&rddassetCode=${rddUid}&projectId=${projectId}&forRddAssetCode=false&token=${token}&coordinate=${coordinate}`
            window.open(url, "_blank");
            openedRef.current = true;
            } else {
                 const url = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${dpCode}&activityCode=${proposalUid}&rddassetCode=${rddUid}&projectId=${projectId}&forRddAssetCode=false&token=${token}&coordinate=${coordinate}`
            window.open(url, "_blank");
            openedRef.current = true;
            }
           
        }
    }, []);

    return (
        <div className="text-center mt-5">
            <h4>Gram Manchitra has been opened in a new tab</h4>
            <button className="btn btn-danger mt-3" onClick={() => nav(-1)}>
                Back
            </button>
        </div>
    );
};

export default MapfunctionForTechnicalSanction;
